export const isCodeInputParametersEnabled = (value) =>
  value === true || value === 1 || value === '1'

const getStringValue = (value) => {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value)
}

export const createCodeInputParameter = (index = 0) => ({
  name: '',
  identifier: `p${index + 1}`,
  default_value: '',
})

export const createRuntimeCodeInputParameter = (index = 0) => ({
  name: '',
  identifier: `p${index + 1}`,
  value: '',
})

export const normalizeCodeInputParameters = (value) => {
  let nextValue = value

  if (typeof nextValue === 'string') {
    try {
      nextValue = JSON.parse(nextValue)
    } catch {
      nextValue = []
    }
  }

  if (!Array.isArray(nextValue)) {
    return []
  }

  return nextValue.map((item, index) => {
    const parameter = item && typeof item === 'object' ? item : {}

    return {
      name: getStringValue(parameter.name ?? parameter.title ?? parameter.label),
      identifier: getStringValue(
        parameter.identifier ?? parameter.key ?? parameter.pointer ?? parameter.code ?? `p${index + 1}`,
      ),
      default_value: getStringValue(
        parameter.default_value ?? parameter.defaultValue ?? parameter.value,
      ),
    }
  })
}

export const getRuntimeCodeInputParameters = (value) =>
  normalizeCodeInputParameters(value).map((parameter) => ({
    name: parameter.name,
    identifier: parameter.identifier,
    value: parameter.default_value,
  }))

export const buildCodeInputParametersStdin = (parameters) => {
  if (!Array.isArray(parameters) || !parameters.length) {
    return ''
  }

  return `${parameters.map((parameter) => getStringValue(parameter?.value)).join('\n')}\n`
}
